import React from 'react';
import moment from 'moment';
import BlockSelectField from '@common/components/FormElements/BlockSelectField';

const optionsForPerDateTimeRange = (options) =>
  options.map((option, index) => {
    const startDate = moment(option.startDate).format('MMM DD');
    const endDate = moment(option.endDate).format('MMM DD');
    const dateString = startDate === endDate ? startDate : `${startDate} - ${endDate}`;
    const startTime = option?.startTime?.substr(0, 5);
    const endTime = option?.endTime?.substr(0, 5);

    return {
      label: `${dateString} : ${startTime} - ${endTime}`,
      value: index,
    };
  });

export const PerDateTimeRange = ({ field, options }) => {
  return (
    <BlockSelectField
      onChange={(value) => {
        field.onChange(value);
      }}
      value={field.value}
      options={optionsForPerDateTimeRange(options)}
    />
  );
};
